
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, HStack, Image, Text, useToast, VStack } from '@chakra-ui/react'
import loadingSpinner from 'assets/lottie/loader_wicar.gif'
import { useVehicles } from 'context'
import { AssistanceRequestType } from 'context/types'
import { themeColors } from 'theme'

import CustomAlert from 'components/CustomAlert'
import { CardBody, CardContainer } from 'components/CustomCard'
import { CarRecoveryIcon, CarRecoverySuccessIcon, InfoIcon } from 'components/SVGS'

export const RecoverVehicle = () => {
  const history = useNavigate()
  const [code, setCode] = useState<string | null>(null)
  const toast = useToast()

  const { checkCurrentVehicle, sendRoadAssistanceRequest, getVehicleLocation,
    vehicleState: { loading, error, state: { vehicle, vehicleLocation: { latitude, longitude } } }
  } = useVehicles()

  const { icon: { interrogationIconColor }, text: { smallText } } = themeColors

  const checkVehicle: () => void = async () => {
    const notVehicle = await checkCurrentVehicle()

    if (notVehicle) history('/my-vehicles')
  }

  useEffect(() => {
    if (!vehicle) checkVehicle()

    if (vehicle) if (!vehicle.isPremium) history('/my-vehicles')

    if (vehicle) getVehicleLocation(vehicle.id, false, vehicle.isRestricted)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle])

  const handleRequestRecovery = async () => {
    const data: AssistanceRequestType = {
      vehicleId: vehicle?.id || '',
      requirementId: '5230',
      serviceId: '3428',
      latitude,
      longitude,
    }

    setCode(await sendRoadAssistanceRequest(data))
  }

  const handleGoBack = () => {
    history('/my-vehicles')
  }

  useEffect(() => {
    if (error)
      toast({
        description: error,
        variant: 'left-accent',
        status: 'error',
        position: 'top',
        duration: 5000,
        isClosable: true
      })

  }, [error, toast])

  if (loading && !vehicle)
    return (
      <VStack alignItems='center' w='100%'>
        <Image
          w={'120px'}
          h={'120px'}
          alt={'loading_wicar'}
          src={loadingSpinner}
        />
      </VStack>
    )

  return (
    <CardContainer isScreen onClose={handleGoBack}>
      <CardBody>
        {code === null
          ? <VStack w='full' spacing={4}>
            <HStack>
              <InfoIcon size={7} fill={interrogationIconColor} />
              <Text variant='XS'>Recuerda dar uso a este servicio solo en casos de robo o pérdida de tu vehículo</Text>
            </HStack>
            <CustomAlert>
              <CarRecoveryIcon size={100} />
              <Text variant='LG_SB' textAlign='center'>
                Activa la búsqueda y recuperación de tu vehículo en caso de robo
              </Text>
              <Text variant='SM'>
                Al activar este servicio se notificará a Carabineros de forma automática para iniciar la búsqueda de
                tu vehículo robado
              </Text>
            </CustomAlert>
            <Button w='full' onClick={handleRequestRecovery} isLoading={loading} loadingText='Confirmando...'>
              Confirmar
            </Button>
            <Button w='full' variant='secondary' isDisabled={loading} onClick={() => history('/my-vehicles')}>
              Volver
            </Button>
          </VStack>
          : <VStack w='full' spacing={6}>
            <CarRecoverySuccessIcon size={100} />
            <Text variant='LG_SB' textAlign='center'>La búsqueda y recuperación de tu vehículo ha sido activada</Text>
            <Text variant='SM'>
              Se ha ingresado tu solicitud de asistencia en ruta, un ejecutivo se contactará contigo en los próximos
              minutos.
            </Text>
            <VStack w='full'>
              <Text textAlign='start' w='full' variant='SM_SB' color={smallText}>Número de atención</Text>
              <Box p={4} bg='gray.900' w='full' my={2} rounded='3xl'>
                <Text textAlign='center' variant='LG_SB'>{code}</Text>
              </Box>
              <Text textAlign='center' variant='XS' color={smallText}>También lo enviaremos a tu correo</Text>
            </VStack>
            <Button w='full' onClick={() => history('/my-vehicles')} isLoading={loading} loadingText='Confirmando...'>
              ENTENDIDO
            </Button>
          </VStack>
        }
      </CardBody>
    </CardContainer>
  )
}
